import { GrupoDTO, IGrupoDTO } from "./Grupo.DTO";
import { EncuestaDTO, IEncuestaDTO } from "./Encuesta.DTO";
import { EnvioDTO, IEnvioDTO } from "./Envio.DTO";
import { ClienteDTO } from "./Cliente.DTO";
import { Nilable } from "@shared/utils";

export interface IInvestigacionDTO {
    id: number;
    customer: number;
    campaigns: Nilable<IGrupoDTO[] | number[]>;
    groups: Nilable<IGrupoDTO[] | number[]>;
    combos: IEncuestaDTO[];
    series: IEnvioDTO[];
    name: string;
    n: number;
    to_date: Nilable<string>;
    from_date: Nilable<string>;
    target_country: string[];
    from_dashboard: boolean;
    enabled: boolean;
    has_universe: boolean;
}

export class InvestigacionDTO {
    public id = 0;
    public cliente = new ClienteDTO();
    public grupos: GrupoDTO[] = [];
    public encuestas: EncuestaDTO[] = [];
    public envios: EnvioDTO[] = [];
    public nombre = "";
    public n = 500;
    public fechaHasta: Nilable<Date> = null;
    public fechaDesde: Nilable<string> = null;
    public targetPais: string[] = [];
    public desdeDashboard = false;
    public activado = true;
    public tieneCuotas = false;

    constructor(json: Nilable<Partial<IInvestigacionDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IInvestigacionDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.customer != null) {
            this.cliente = new ClienteDTO({ id: json.customer });
        }
        if (json.campaigns != null || json.groups != null) {
            const grupos = json.campaigns ?? json.groups;
            if (grupos != null && grupos.length !== 0) {
                const esNumero = !isNaN(parseInt(grupos[0].toString(), 10));
                if (esNumero) {
                    this.grupos = (grupos as number[]).map(grupoId => new GrupoDTO({ id: grupoId })) ?? [];
                } else {
                    this.grupos = (grupos as IGrupoDTO[]).map(grupo => new GrupoDTO(grupo)) ?? [];
                }
            }
        }
        if (json.combos != null) {
            this.encuestas = json.combos?.map(encuesta => new EncuestaDTO(encuesta)) ?? [];
        }
        if (json.series != null) {
            this.envios = json.series?.map(envio => new EnvioDTO(envio)) ?? [];
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.n != null) {
            this.n = json.n;
        }
        if (json.to_date != null) {
            this.fechaHasta = new Date(`${json.to_date} 00:00:00Z-3`);
        }
        if (json.from_date != null) {
            this.fechaDesde = json.from_date;
        }
        if (json.target_country != null) {
            this.targetPais = json.target_country;
        }
        if (json.from_dashboard != null) {
            this.desdeDashboard = json.from_dashboard;
        }
        if (json.enabled != null) {
            this.activado = json.enabled;
        }
        if (json.has_universe != null) {
            this.tieneCuotas = json.has_universe;
        }
    }

    public toJSON(): IInvestigacionDTO {
        return {
            id: this.id,
            customer: this.cliente.id,
            campaigns: this.grupos?.map(grupo => grupo.obtenerJSON()),
            groups: this.grupos?.map(grupo => grupo.obtenerJSON()),
            combos: this.encuestas?.map(encuesta => encuesta.toJSON()),
            series: this.envios?.map(envio => envio.toJSON()),
            name: this.nombre,
            n: this.n,
            to_date: this.fechaHasta?.toJSON().substr(0, this.fechaHasta?.toJSON().indexOf("T")) ?? null,
            from_date: this.fechaDesde,
            target_country: this.targetPais,
            from_dashboard: this.desdeDashboard,
            enabled: this.activado,
            has_universe: this.tieneCuotas
        };
    }

    public formatear() {
        this.grupos.forEach(grupo => {
            grupo.envios = this.envios.filter(serie => serie.grupoId === grupo.id);
        });
    }

    public clon(): InvestigacionDTO {
        const clon = new InvestigacionDTO(this.toJSON());
        clon.grupos = this.grupos.map(grupo => grupo.clon());
        return clon;
    }
}
